
import { defineComponent, PropType } from 'vue'
import { RunStatus } from '~/types/types'
import { runStatusIcon, runStatusIconColor } from '~/utils/ui'
import { getHumanizedTimeFromNow } from '~/utils/date'
import UIReportCardGrade from '~/components/Common/UI2/Grade/UIReportCardGrade.vue'
import UILabel from '~/components/Common/UI2/Label/UILabel.vue'
import UICard from '~/components/Common/UI2/Card/UICard.vue'

type GradeType = 'A' | 'B' | 'C' | 'D' | null

export default defineComponent({
  name: 'PRListItem',
  components: {
    UIReportCardGrade,
    UILabel,
    UICard
  },
  props: {
    title: {
      type: String,
      required: true
    },
    status: {
      type: String as PropType<RunStatus>,
      default: RunStatus.Pass
    },
    prNumber: {
      type: String,
      required: true
    },
    repoName: {
      type: String,
      default: undefined
    },
    isPrivate: {
      type: Boolean,
      default: false
    },
    provider: {
      type: String,
      default: 'gh'
    },
    timestamp: {
      type: String,
      default: undefined
    },
    grade: {
      type: String as PropType<GradeType>,
      default: null
    },
    issuesFixed: {
      type: Number,
      default: 0
    },
    issuesIntroduced: {
      type: Number,
      default: 0
    },
    issuesSuppressed: {
      type: Number,
      default: 0
    },
    runId: {
      type: String,
      default: undefined
    }
  },
  methods: {
    getHumanizedTimeFromNow
  },
  computed: {
    to(): string | undefined {
      if (!this.runId || !this.repoName) return undefined
      const { provider, owner } = this.$route.params
      return `/${provider}/${owner}/${this.repoName}/run/${this.runId}`
    },
    statusIcon(): string {
      return runStatusIcon(this.status)
    },
    statusIconColor(): string {
      return runStatusIconColor(this.status)
    },
    isPending(): boolean {
      return this.status === RunStatus.Pend
    },
    providerIcon(): string {
      return this.$providerMetaMap[this.provider]?.icon || 'github'
    },
    hasIssueStats(): boolean {
      return Boolean(this.issuesFixed || this.issuesIntroduced || this.issuesSuppressed)
    },
    formattedTimestamp(): string {
      if (!this.timestamp) return ''
      return getHumanizedTimeFromNow(this.timestamp)
    }
  }
})
